import React from 'react';
import FilterSearchBar from '../../../components/ui/FilterSearchBar';

const HistoryFilters = ({ onSearch, onFilter }) => {
  const filterOptions = [
    {
      key: 'type',
      label: 'Validation Type',
      type: 'select',
      options: [
        { value: 'single', label: 'Single Email' },
        { value: 'bulk', label: 'Bulk Validation' }
      ]
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'completed', label: 'Completed' },
        { value: 'processing', label: 'Processing' },
        { value: 'failed', label: 'Failed' },
        { value: 'cancelled', label: 'Cancelled' }
      ]
    },
    {
      key: 'dateFrom',
      label: 'Date From',
      type: 'date'
    },
    {
      key: 'dateTo',
      label: 'Date To',
      type: 'date'
    },
    {
      key: 'minEmails',
      label: 'Min Emails',
      type: 'text',
      placeholder: 'e.g., 100'
    },
    {
      key: 'maxEmails',
      label: 'Max Emails',
      type: 'text',
      placeholder: 'e.g., 10000'
    }
  ];

  return (
    <div className="mb-6">
      <FilterSearchBar
        onSearch={onSearch}
        onFilter={onFilter}
        searchPlaceholder="Search by file name, session ID, or email..."
        filters={filterOptions}
        showFilters={true}
        className="w-full"
      />
    </div>
  );
};

export default HistoryFilters;